export const TERMS_AND_CONDITION_WARNING_KIND = {
  TICKET: 'ticket',
  INVOICE: 'invoice'
}

export const TERMS_AND_CONDITION_EXPIRED_MESSAGE =
  'This account\'s Terms and Conditions link has expired without a signature. Choose Create & Resend to send a new agreement link, or Create Anyway to continue without resending.'

export function hasTermsAndConditionExpiredWarning (client, kind) {
  if (!client?.termsAndConditionExpiredAssignmentId) {
    return false
  }

  if (kind === TERMS_AND_CONDITION_WARNING_KIND.TICKET) {
    return client?.termsAndConditionTicketWarning === true
  }

  if (kind === TERMS_AND_CONDITION_WARNING_KIND.INVOICE) {
    return client?.termsAndConditionInvoiceWarning === true
  }

  return false
}
